import React, { useContext } from 'react';
import { Header } from './components/header.jsx';
import { Content } from './components/content.jsx';
import { CartContext } from './context.jsx';
import { FooterContainer } from './containers/footer.jsx';
import { ContentContainer as ContentContainerV1 } from './containers/content.jsx';
import { Footer as FooterV1 } from './components/footer.jsx';

const Cart = () => {
  const {
    cart,
    closeCart
  } = useContext(CartContext);

  if (!cart) {
    return (
      <>
        <Header count={0} onCloseCart={closeCart} />
        <Content>
          <div className="spinner spinner--red">
            <div className="spinner__element"></div>
          </div>
        </Content>
      </>
    );
  }

  return (
    <>
      <Header count={cart.item_count} onCloseCart={closeCart} />
      <ContentContainerV1 cart={cart} />
      <FooterContainer Component={FooterV1} cart={cart} />
    </>
  );
};

export default Cart;
